import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem('sts_auth') === 'true';

  if (!isAuthenticated) {
    return <Navigate to="/sts-login" replace />;
  }

  return children;
};

export default ProtectedRoute;
